import React from 'react';
import ChristmasLogo from './resources/ChristmasLogo.png';
import GDDImage from './resources/GDDLuLu.jpg';

import './App.css';

class App extends React.Component {
  // var audio = new Audio('./resources/christmas.wav');
  // audio.play();
  constructor() {
    super();
    this.state = {
      loading: true
    }
  }

  componentDidMount() {
    setTimeout(this.finishLoading.bind(this), 4000);//if it doesn't load for 10s just show
  }

  finishLoading() {
    this.setState({
      loading: false
    });
  }

  render() {
    return (
      <div className="App">
        <div className="App-header">
          <img className={this.state.loading ? "App-logo App-logo-loading shake" : "App-logo move"} src={ChristmasLogo}/>
          <div className="title" >LuLu's Adventure</div>
          
          <div className={this.state.loading ? "content-container" : "opacity"}>
            <p>
            LuLu’s Adventure is just a healing game with lovable characters and beautiful scenery of nature. The changing temperature has placed havoc on LuLu’s peaceful island. LuLu has stepped forward to take an action. He sets out to find the legendary crystal acorn that can grow to produce water. 
            </p>
            <img className="gif gif-1" src="https://storage.googleapis.com/luluadventure/LuLu1.gif" onLoad={this.finishLoading.bind(this)}/>
            <p>
            The number of acorns growing each year is constantly decreasing due to lack of water. LuLu uses acorns scattered throughout the map to fill energy levels and defeat predators. Use the limited resources wisely. Think fast because LuLu will die once he runs out of acorns to eat. Help LuLu defeat the monstrous predators and make LuLu into a hero squirrel that saves his village. 
            </p>
            <img className="gif gif-2" src="https://storage.googleapis.com/luluadventure/LuLu2.gif"/>
            <p>
            LuLu’s Adventure presents an issue of limited resources. Resources in the real world and nature are always finite. Throughout the game, the players will learn to minimize the resources they use. They will constantly test different strategies to consume less resources. This constant testing and strategizing are what the world needs to solve big issues like climate change, and LuLu's Adventure creates a microcosm of the world.
            </p>
          </div>
        </div>
        <div className='GDD-container'>
          <div className="find-out-more" >Find our more:</div>
          <img className="GDD-image" src={GDDImage}/>
          <div className='download-button-container'>
            <a className="download-button" href="https://storage.googleapis.com/luluadventure/GDD_LuLu.pdf">
                  DOWNLOAD
            </a>
          </div>
        </div>
        <div className='footer'></div>
      </div>
    );
  }
}

export default App;
